import SideModal from "/src/components/modal/SideModal/SideModal";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import { useMemo } from 'react';
import './ModalAgentPerformance.css';
import "tippy.js/dist/tippy.css";
import AgentsPerformanceHeader from '../AgentsPerformanceHeader/AgentsPerformanceHeader';
import ScoreBarLinear from "../../../../../components/UI/ScoreBarLinear/ScoreBarLinear";
import ModalAgentPerformanceArray from "../ModalAgentPerformanceArray/ModalAgentPerformanceArray";

const CATEGORY_COLORS = ["#4c9aff", "#36b37e", "#ff8b00", "#c33b8f", "#00b8d9", "#6554c0"];

const ModalAgentPerformance = NiceModal.create(({ item, onRefresh }) => {
    const modal = useModal();
    const { onClose } = useModalHelper(modal);

    const data = item || {};
    const enrichedData = data.criteriaBreakdown || [];

    const categoryStats = useMemo(() => {
        // categoryBreakdown already comes pre-aggregated from the backend
        return (data.categoryBreakdown || []).map((cat, index) => ({
            categoryId: cat.category,
            avg: cat.score,
            color: CATEGORY_COLORS[index % CATEGORY_COLORS.length]
        }));
    }, [data]);

    const TOP_N = 3;

    const topCategories = useMemo(() => {
        return [...categoryStats]
            .sort((a, b) => b.avg - a.avg)
            .slice(0, TOP_N);
    }, [categoryStats]);

    const handleClose = () => {
        onClose();
        onRefresh && onRefresh()
    }
    return (
        <SideModal id={modal.id} autoClose={true} onClose={handleClose} style={{ width: '80%', zIndex: '1000' }} autoCloseChangePageOnly={false} name="agent_performance_modal">
            <div>
                <div className="button-leave" id="close_modal_container close_convo_modal_container" onClick={handleClose}>
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>

                </div>
                <br></br>
                <div className="title-modal-agent-performance">{data.agent}</div>
            </div>
            <br></br>
            <div className="modal-performance-agent-info">
                <div className="container-icon-agent"> <i className="fas fa-users"></i></div>
                <div className="agent-team">{data.unit || ""}</div>
            </div>
            <div className="divider div-transparent div-dot"></div>
            <div>
                <AgentsPerformanceHeader stats={{
                    overallScore: data.avgScore,
                    interactions: data.interactions,
                    avgVoiceDuration: data.avgVoiceDuration,
                    speakerRatio: data.speakerRatio,
                    training: null
                }} agentFilter={data.agent} />
            </div>
            <div className="divider div-transparent div-dot"></div>

            <div className="modal-performance-agent-data">
                <div className="container-categories-top">
                    <div style={{fontWeight: "bold"}}>Top criteria categories</div>
                    <br></br>

                    {topCategories.map((cat, i) => (
                        <div key={cat.categoryId} className="cat-item">
                            <div className="cat-name">{cat.categoryId}</div>
                            <div className="cat-score">
                                <ScoreBarLinear score={cat.avg} color={cat.color} />
                                <div>{cat.avg}% <span style={{ fontWeight: "normal", fontSize: "12px", color: "#888" }}>Avg score</span></div>
                            </div>
                            {i < topCategories.length - 1 && <div className="divider div-transparent div-dot"></div>}

                        </div>
                    ))}
                </div>
                <div className="container-categories-array">
                    <ModalAgentPerformanceArray enrichedData={enrichedData} agent={data.agent} />
                </div>
            </div>

        </SideModal>
    );
});

export default ModalAgentPerformance;
